import React from 'react';
import PropTypes from 'prop-types';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DetailWrapper from '../../CardRow/DetailWrapper';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import { useForm } from 'react-hook-form';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const StyledPurchaseValueInputs = styled.span`
  display: inline-flex;
`;

const getOptions = (option) => {
  return (
    option.map((item) => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))
  );
};

const PriceCoefficient = ({
  handlers,
  editable,
  setEditable,
  isNew,
  handler,
  idPanel,
  setOpen,
  title,
  currentValues,
  currentHandler,
  setPurchaseIndexTypeId,
  purchaseIndexTypeId,
  enums,
  loaders,
}) => {
  const {
    sendHandler,
  } = handlers;


  const intl = useIntl();
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const continueTitle = 'app.buttons.continue';
  const purchaseIndexTypeIdTitle = 'app.contracts.pnMethod';

  const { handleSubmit, register, errors } = useForm();

  const handleChange = (idButton) => {
    if (!isNew) {
      setEditable(!editable);
      if (idButton !== 'cancel') {
        setOpen(true);
        sendHandler();
      }
    } else {
      handler(idPanel, true);
    }
  };

  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <form style={{ display: 'grid' }} onSubmit={handleSubmit(handleChange)}>
            {setPurchaseIndexTypeId &&
                  <CustomTextField
                    id="1"
                    name={'purchaseIndexTypeId'}
                    onChange={(event) => {
                      setPurchaseIndexTypeId(event.target.value);
                    }}
                    select
                    title={purchaseIndexTypeIdTitle}
                    value={purchaseIndexTypeId}
                    disabled={!editable}
                    SelectProps={{
                      native: true,
                    }}
                    variant="outlined"
                    inputRef={register({
                      required: dataMissing,
                    })}
                    helperText={errors?.purchaseIndexTypeId?.message}
                    error={!!errors?.purchaseIndexTypeId}
                  >
                    <option value={null} />
                    {getOptions(enums?.purchaseIndexTypes)}
                  </CustomTextField>
            }
            {
              currentValues&&
              currentValues.map((item) => (
                <StyledPurchaseValueInputs key={`container-${item.idTariff}`}>
                  <CustomTextField
                    key={item.idTariff}
                    variant="outlined"
                    label={`${title} ${item.idTariff}`}
                    name={item.idTariff.toString()}
                    value={
                      item.value.toLocaleString('cs-CZ', {
                        maximumFractionDigits: 3,
                      })
                    }
                    disabled={!editable}
                    InputProps={{
                      inputComponent: CustomNumberFormat,
                    }}
                    inputRef={register({
                      required: dataMissing,
                    })}
                    helperText={errors[item.idTariff]?.message}
                    error={!!errors[item.idTariff]}
                    onChange={(event) => {
                      const index = currentValues.findIndex((e) => {
                        return e.idTariff === item.idTariff;
                      });
                      currentHandler((oldState) => {
                        const newState = [...oldState];
                        newState[index].value = event.target.value;
                        return newState;
                      });
                    }}
                  />
                  {purchaseIndexTypeId === 'RI+K' ? <CustomTextField
                    key={`${item.idTariff}-value2`}
                    variant="outlined"
                    label={`K+ ${title} ${item.idTariff}`}
                    name={`${item.idTariff.toString()}-value2`}
                    value={
                      item?.value2?.toLocaleString('cs-CZ', {
                        maximumFractionDigits: 3,
                      })
                    }
                    disabled={!editable}
                    InputProps={{
                      inputComponent: CustomNumberFormat,
                    }}
                    inputRef={register({
                      required: dataMissing,
                    })}
                    helperText={errors[item.idTariff]?.message}
                    error={!!errors[item.idTariff]}
                    onChange={(event) => {
                      const index = currentValues.findIndex((e) => {
                        return e.idTariff === item.idTariff;
                      });
                      currentHandler((oldState) => {
                        const newState = [...oldState];
                        newState[index].value2 = event.target.value;
                        return newState;
                      });
                    }}
                  /> : null}
                </StyledPurchaseValueInputs>
              ))
            }
            <ButtonWrapper>
              <DefaultButton
                id={'cancel'}
                primary={false}
                disabled={!editable}
                title={cancel}
                onClick={(event) => {
                  handleChange(event.currentTarget.id);
                }}
              />
              <DefaultButton
                primary={true}
                disabled={!editable}
                type="submit"
                title={isNew ? continueTitle : save}
                loaders={loaders}
              />
            </ButtonWrapper>
          </form>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

PriceCoefficient.propTypes = {
  title: PropTypes.any,
  currentValues: PropTypes.any,
  currentHandler: PropTypes.any,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  register: PropTypes.any,
  errors: PropTypes.object,
  setEditable: PropTypes.func,
  handler: PropTypes.func,
  idPanel: PropTypes.any,
  setOpen: PropTypes.func,
  setPurchaseIndexTypeId: PropTypes.any,
  purchaseIndexTypeId: PropTypes.any,
  enums: PropTypes.any,
  transaction: PropTypes.object,
  loaders: PropTypes.any,
};

export default PriceCoefficient;
